import React from 'react';
import { toJS } from 'mobx';
import './index.scss';

//api
import { api } from '../../../functions/api'

//material-ui
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';

//custom components
import CustomSnackbar from '../../../components/global/snackbar';
import DeleteDialog from '../../../components/global/deleteDialog';
import Box from '../../../components/basic/box';
import CustomInput from '../../../components/basic/input';
import CustomIconButton from '../../../components/basic/customIconButton';

//libraries
import { inject, observer } from 'mobx-react';
import Icon from '@mdi/react'
import { mdiPlus, mdiMinus, mdiDelete, mdiArrowLeft, mdiDotsVertical } from '@mdi/js';
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import { IconButton, InputAdornment, MuiThemeProvider } from "@material-ui/core";
import CalendarToday from "@material-ui/core/SvgIcon/SvgIcon";
import MomentUtils from "@date-io/moment";
import moment from 'moment';
import 'moment/locale/sk';

//calendar
import { createMuiTheme } from '@material-ui/core';


const materialTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      underline: {
        "&::after": {
          borderBottomColor: "#777777",
          borderBottom: "2px solid #777777 !important"
        }
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#FF7800",
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      },
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: "#FF7800",
      },
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: "#FF7800",
      },
      thumb: {
        backgroundColor: "#FF7800",
        borderColor: "#FF7800",
      }
    },
    MuiPickersClockNumber: {
      selected: {
        backgroundColor: "#FF7800",

      },
    },
    MuiPickersDay: {
      day: {
        color: "#777777",
      },
      selected: {
        backgroundColor: "#FF7800",
        '&:hover': {
          backgroundColor: "#FF7800",
        }
      },
      current: {
        color: "#777777"
      },
    },
    MuiPickersYear: {
      root: {
        color: "#777777",
        '&:hover': {
          color: "#FF7800",
        }
      },
      selected: {
        color: "#FF7800 !important",
        '&:hover': {
          color: "#FF7800",
        }
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: "#777777",
      },

    },
  },
});

function getSteps () {
  return ['Select master blaster campaign settings', 'Create an ad group', 'Create an ad', 'sfasfsafasdasfdasdf'];
}


const TIMEOUT = 3000;

@inject('internal')
@inject('translate')
@observer
export default class ShoppingCart extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      activeStep: 0,
      loading: false,
      openSnackbar: false,
      message: "",
      openDeleteDialog: false,
      idForDelete: 0,
      value: 0, //tabs
      accept: false,
    }
  }

  componentDidMount () {
    if (toJS(this.props.internal.user)
      && toJS(this.props.internal.user.data)
      && toJS(this.props.internal.user.data.permissions)
      && toJS(this.props.internal.user.data.permissions.shopping_cart)
      && toJS(this.props.internal.user.data.permissions.shopping_cart.use)) {

      this.props.internal.setRoute(this.props.history, this.props.location.pathname)
    } else {
      this.props.internal.setRoute(this.props.history, this.props.location.pathname)
      this.props.internal.pushRoute('/')
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
    }
  }

  timeout = null;

  componentWillUnmount () {
    clearTimeout(this.timeout)
  }

  turnOffSnackBar = () => {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.setState({
        message: "",
        openSnackbar: false
      })
    }, TIMEOUT)
  }

  buttonsNextText (stepIndex) {
    switch (stepIndex) {
      case 0:
        return this.props.translate.i18n.MODULES.SHOPPING_CART.NEXT_TO_PAYMENTS;
      case 1:
        return this.props.translate.i18n.MODULES.SHOPPING_CART.NEXT_TO_SUMMARY;
      case 2:
        return this.props.translate.i18n.MODULES.SHOPPING_CART.NEXT_TO_COMPLETE_ORDER;
      default:
        return false;
    }
  }

  buttonsBackText (stepIndex) {
    switch (stepIndex) {
      case 0:
        return <div>
          <a href="/products" style={{color: "white"}}>{this.props.translate.i18n.MODULES.SHOPPING_CART.BACK_TO_PRODUCTS}</a>
        </div>
      case 1:
        // return this.props.translate.i18n.MODULES.SHOPPING_CART.BACK_TO_SHOPPING_CART;
        return <div>
          <Icon path={mdiArrowLeft} style={{fill: "white"}} size={1} className={'icon'}/><span className={'text'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.BACK_TO_SHOPPING_CART}</span>
        </div>
      case 2:
        // return this.props.translate.i18n.MODULES.SHOPPING_CART.BACK_TO_PAYMENST;
        return <div>
          <Icon path={mdiArrowLeft} style={{fill: "white"}} size={1} className={'icon'}/><span className={'text'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.BACK_TO_PAYMENST}</span>
        </div>
      default:
        return false
    }
  }

  completeOrder = async () => {
    this.setState({loading: true})
    let clietnId = toJS(this.props.internal.user.data.client.id)
    let deliveryDate = toJS(this.props.internal.clientDeliveryDate);
    let upload_data = await api({
      method: 'post',
      url: 'clients/' + clietnId + '/orders',
      authorization: this.props.internal.user.access_token,
      params: {
        client_note: toJS(this.props.internal.clientNote),
        delivery_date: deliveryDate ? deliveryDate.format('YYYY-MM-DD') : null,
        order_number: toJS(this.props.internal.clientOrderNumber),
      }
    })

    if (upload_data.success === false && upload_data.status === 201) {
      this.props.internal.setSnackbar(upload_data.data.message, true)
      this.props.internal.setAllDataFromShoppingCart(upload_data.data.data);
      //this.setState({message: upload_data.data.message, openSnackbar: true})
      this.props.internal.setClientNote("")
      this.props.internal.setClientOrderNumber("")
      this.props.internal.setClientDeliveryDate("")
    }
    this.setState({loading: false})
  }

  handleNext = () => {
    if (this.state.activeStep === 2) {
      this.completeOrder();
    }

    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleAccept = (event) => {
    this.setState({checked: !this.state.checked})
  }

  render () {
    const steps = getSteps();
    const {activeStep} = this.state;
    const {value} = this.state;

    let delivery_type = toJS(this.props.internal.allDataFromShoppingCart.delivery_type)
    let payment_type = toJS(this.props.internal.allDataFromShoppingCart.payment_type)
    let branch_id = toJS(this.props.internal.allDataFromShoppingCart.branch_id)

    return (
      this.state.loading ?
        <CircularProgress className={'circular-progress'}/>
        :
        <div className={'shopping-cart'}>
                    <span className={'active-tab-title'}>
                        {activeStep === 0 ? this.props.translate.i18n.MODULES.SHOPPING_CART.SHOPPING_CART : null}
                      {activeStep === 1 ? this.props.translate.i18n.MODULES.SHOPPING_CART.PAYMENTS_TRANSPORTS : null}
                      {activeStep === 2 ? this.props.translate.i18n.MODULES.SHOPPING_CART.SUMMARY : null}
                      {activeStep === 3 ? this.props.translate.i18n.MODULES.SHOPPING_CART.COMPLETE_ORDER : null}
                    </span>
          <Tabs
            value={value}
            onChange={this.handleChange}
            className={'shopping-tabs'}
            fullWidth
            // TabIndicatorProps={{className: 'active-'+activeStep}}
            classes={{
              indicator: `orangeIndicator active-${activeStep}`,

            }}
          >
            <Tab classes={{selected: "item-tab-selected"}} label={
              <div>1. <span className={'tab-name'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.SHOPPING_CART}</span>
              </div>} className={`active`}/>
            <Tab classes={{selected: "item-tab-selected"}} label={
              <div>2. <span className={'tab-name'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.PAYMENTS_TRANSPORTS}</span>
              </div>} className={activeStep > 0 ? ` active` : ""}/>
            <Tab classes={{selected: "item-tab-selected"}} label={
              <div>3. <span className={'tab-name'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.SUMMARY}</span>
              </div>} className={activeStep > 1 ? ` active` : ""}/>
            <Tab classes={{selected: "item-tab-selected"}} label={
              <div>4. <span className={'tab-name'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.COMPLETE_ORDER}</span>
              </div>} className={activeStep > 2 ? ` active` : ""}/>
          </Tabs>
          {activeStep === 0 && <ItemsInCart/>}
          {activeStep === 1 && <PaymentAndTransport/>}
          {activeStep === 2 && <Summary/>}
          {activeStep === 3 && <CompleteOrder/>}


          <div className={'footer-btns'}>
            <Button
              className={`back-btn step-${activeStep}`}
              disabled={(activeStep === 0 && Number(toJS(this.props.internal.numberOfItemsInShopingCart)) > 0) || activeStep === steps.length - 1}
              onClick={this.handleBack}
            >
              {activeStep === steps.length - 1 ? '' : this.buttonsBackText(activeStep)}
            </Button>
            {Number(toJS(this.props.internal.numberOfItemsInShopingCart)) === 0 ?
              null
              :
              this.state.activeStep !== 3 ?
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleNext}
                  className={`next-btn step-${activeStep}`}
                  disabled={(activeStep === 1 && (delivery_type === null || payment_type === null || branch_id === null)) || (!this.state.checked && activeStep === 2) || Number(toJS(this.props.internal.numberOfItemsInShopingCart)) === 0 || this.state.loading ? true : false}
                >
                  {activeStep === steps.length - 1 ? "" : this.buttonsNextText(activeStep)}
                </Button>
                :
                null
            }

            {activeStep === steps.length - 1
              ?
              null
              :
              <div className={'btn-with-checkbox'}>
                {activeStep === 2 ?
                  <ListItem dense onChange={this.handleAccept} className={'list-item accept-order'}>
                    <input id='accept' type="checkbox" value='accept' defaultChecked={this.state.checked}/>
                    <label htmlFor='accept'>
                      {this.props.translate.i18n.MODULES.SHOPPING_CART.SHOPPING_CONDITIONS} (<a href="/static/terms-of-use" target="_blank">{this.props.translate.i18n.MODULES.SHOPPING_CART.SHOW_TOS}</a>)</label>
                  </ListItem>
                  :
                  null
                }
                {/* <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleNext}
                            className={`next-btn step-${activeStep}`}
                            disabled={(activeStep === 1 && (delivery_type_id === null || payment_type_id === null || branch_id === null)) || (!this.state.checked && activeStep === 2) || Number(toJS(this.props.internal.numberOfItemsInShopingCart)) === 0 ? true : false }
                        >
                            {activeStep === steps.length - 1 ? "" : this.buttonsNextText(activeStep)}
                        </Button> */}
              </div>
            }
          </div>
        </div>
    );
  }
}


@inject('internal')
@inject('translate')
@observer
class ItemsInCart extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      loading: false,
      openSnackbar: false,
      message: "",
      openDeleteDialog: false,
      idForDelete: 0,
    }
  }

  componentDidMount () {
    this.loadShoppingCart();
  }

  timeout = null;

  componentWillUnmount () {
    clearTimeout(this.timeout)
  }

  turnOffSnackBar = () => {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.setState({
        message: "",
        openSnackbar: false
      })
    }, TIMEOUT)
  }

  loadShoppingCart = async () => {
    this.setState({loading: true})

    let load_data = await api({
      method: 'get',
      url: 'shopping-cart',
      authorization: this.props.internal.user.access_token,
    })

    this.props.internal.addToShoppingCart(load_data.data.data.items);
    this.props.internal.setAllDataFromShoppingCart(load_data.data.data);
    this.props.internal.updateNumberOfItemsInShopingCart(load_data.data.data.items_count)
    this.setState({loading: false})
  }

  oneMoreOrLess = async (data, option) => {
    this.setState({loading: true})
    let itemId = data.product_id;

    let load_data = await api({
      method: 'patch',
      url: 'shopping-cart',
      authorization: this.props.internal.user.access_token,
      params: {
        product_id: Number(itemId),
        action: option
      }
    })

    if (load_data.success === true) {
      this.setState({message: load_data.data.message, openSnackbar: true})
      // this.loadShoppingCart();
      this.props.internal.addToShoppingCart(load_data.data.data.items);
      this.props.internal.setAllDataFromShoppingCart(load_data.data.data);
      this.props.internal.updateNumberOfItemsInShopingCart(load_data.data.data.items_count)
    }
    this.setState({loading: false})
    this.turnOffSnackBar()
  }


  handleOpenDeleteDialog = (data) => {
    this.setState({openDeleteDialog: true, idForDelete: data.product.id})
  }

  deleteItem = async () => {
    this.setState({loading: true})
    let itemId = this.state.idForDelete;

    let deleted_data = await api({
      method: 'delete',
      url: 'shopping-cart/' + Number(itemId),
      authorization: this.props.internal.user.access_token,
    })

    if (deleted_data.success === true) {
      this.setState({message: deleted_data.data.message, openSnackbar: true, openDeleteDialog: false})
      this.loadShoppingCart();
    }

    this.setState({loading: false})
    this.turnOffSnackBar()
  }

  closeDeleteDialog = () => {
    this.setState({openDeleteDialog: false});
  }

  formatMoney = (data) => {
    const formatter = new Intl.NumberFormat('sk-SK', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    })
    return formatter.format(data)
  }

  render () {
    return (
      this.state.loading && !this.props.internal.shoppingCart.items ?
        <CircularProgress className={'circular-progress'}/>
        :
        <div className={'shopping-cart-items'}>
          <CustomSnackbar message={this.state.message} open={this.state.openSnackbar}/>
          <DeleteDialog
            open={this.state.openDeleteDialog}
            title={this.props.translate.i18n.MODULES.SHOPPING_CART.DELETE_DIALOG_TITLE}
            content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
            btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
            btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
            delete={this.deleteItem}
            close={this.closeDeleteDialog}
          />

          <Paper className={'shopping-cart-container'}>
            <Table className={'shoppign-cart-table'}>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>{this.props.translate.i18n.MODULES.SHOPPING_CART.EAN}</TableCell>
                  <TableCell>{this.props.translate.i18n.MODULES.SHOPPING_CART.TITLE}</TableCell>
                  <TableCell className={'text-right'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.PRICE_WITHOUT_VAT}</TableCell>
                  <TableCell className={'text-right'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.COUNT}</TableCell>
                  <TableCell className={'text-right'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.TOTAL}</TableCell>
                  <TableCell>{this.props.translate.i18n.MODULES.SHOPPING_CART.ACTIONS}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Number(toJS(this.props.internal.numberOfItemsInShopingCart)) > 0
                  ?
                  this.props.internal.shoppingCart.map((item, itemIndex) => {
                    if (null === item.product) return null;
                    return (
                      <TableRow key={item.product.id}>
                        <TableCell className={'button-detail'}>
                          <CustomIconButton
                            id={item.product.id}
                            label="More"
                            dropdownMenu
                            items={[{
                              title: this.props.translate.i18n.GLOBAL.BUTTONS.DETAIL,
                              action: "detail"
                            }]}
                            module={'/products'}
                            data={item.product}
                            production={item.product.production}
                            backToShoppingCart
                          >
                            <Icon path={mdiDotsVertical} size={1}/>
                          </CustomIconButton>
                        </TableCell>
                        <TableCell>{item.product.code}</TableCell>
                        <TableCell>{item.product.name}</TableCell>
                        <TableCell numeric>{this.formatMoney(item.total_price)}</TableCell>
                        <TableCell numeric>{item.quantity}</TableCell>
                        <TableCell numeric>{this.formatMoney(item.total_price_with_vat)}</TableCell>
                        <TableCell className={'icons'}>
                          <span onClick={() => this.oneMoreOrLess(item, "increment")}><Icon path={mdiPlus} size={1} className={'plus'}/></span>
                          <span onClick={() => this.oneMoreOrLess(item, "decrement")}><Icon path={mdiMinus} size={1} className={'minus'}/></span>
                          <span onClick={() => this.handleOpenDeleteDialog(item)}><Icon path={mdiDelete} size={1} className={'delete'}/></span>
                        </TableCell>
                      </TableRow>
                    );
                  })
                  :
                  <TableRow>
                    <TableCell colSpan="6" style={{textAlign: 'center'}}>{this.props.translate.i18n.GLOBAL.ALERTS.SHOPPING_CART_IS_EMPTY}</TableCell>
                  </TableRow>
                }
              </TableBody>
            </Table>
          </Paper>
          <Paper className={'summary'}>
            <div className={'flex with-vat'}>
              <p>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITHOUT_VAT}</p>
              <span>{this.formatMoney(this.props.internal.allDataFromShoppingCart.products_total)}</span>
            </div>
            <div className={'flex without-vat'}>
              <p>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITH_VAT}</p>
              <span>{this.formatMoney(this.props.internal.allDataFromShoppingCart.products_total_with_vat)} </span>
            </div>
          </Paper>
        </div>
    )
  }

}


@inject('internal')
@inject('translate')
@observer
class PaymentAndTransport extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      loading: false,
      openSnackbar: false,
      message: "",
      locale: 'sk',
      checkedPayment: [toJS(this.props.internal.allDataFromShoppingCart.payment_type_id)],
      checkedDelivery: [toJS(this.props.internal.allDataFromShoppingCart.delivery_type_id),],
      branch: toJS(this.props.internal.allDataFromShoppingCart.branches[0]),
      // branch: ""

    }
  }

  componentDidMount () {
    //this.loadBranchces();
    if (toJS(this.props.internal.allDataFromShoppingCart.branch)) {
      this.setState({branch: toJS(this.props.internal.allDataFromShoppingCart.branch)})
    }
    let result = ""
    // if(toJS(this.props.internal.allDataFromShoppingCart.branch_id) === null) {

    if (toJS(this.props.internal.allDataFromShoppingCart.available.payment_types).length === 0) {
      result += this.props.translate.i18n.GLOBAL.ALERTS.PAYMENT_TYPES_IS_NOT_DEFINED + " ";
    }
    if (toJS(this.props.internal.allDataFromShoppingCart.available.delivery_types).length === 0) {
      result += this.props.translate.i18n.GLOBAL.ALERTS.DELIVERY_TYPES_IS_NOT_DEFINED + " ";
    }
    if (toJS(this.props.internal.allDataFromShoppingCart.branches).length === 0) {
      result += this.props.translate.i18n.GLOBAL.ALERTS.BRANCHE_IS_NOT_DEFINED
    }

    if (result !== "") {
      this.props.internal.setSnackbar(result, true)
    }

    if (toJS(this.props.internal.clientNote) !== "") {
      this.note.setValue(toJS(this.props.internal.clientNote))
    }

  }

  timeout = null;

  componentWillUnmount () {
    clearTimeout(this.timeout)
    // this.props.internal.setAllDataFromShoppingCart(load_data.data.data);
  }

  turnOffSnackBar = () => {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.setState({
        message: "",
        openSnackbar: false
      })
    }, TIMEOUT)
  }

  updateDeliveryType = async (id) => {

    let load_data = await api({
      method: 'patch',
      url: 'shopping-cart',
      authorization: this.props.internal.user.access_token,
      params: {
        action: "attributes",
        delivery_type_id: id
      }
    })

    if (load_data.success === true) {
      this.setState({message: load_data.data.message, openSnackbar: true})
      this.props.internal.setAllDataFromShoppingCart(load_data.data.data);
      //this.loadShoppingCart();
    }
    this.setState({loading: false})
    this.turnOffSnackBar()

  }

  updatePaymentType = async (id) => {

    let load_data = await api({
      method: 'patch',
      url: 'shopping-cart',
      authorization: this.props.internal.user.access_token,
      params: {
        action: "attributes",
        payment_type_id: id
      }
    })

    if (load_data.success === true) {
      this.setState({message: load_data.data.message, openSnackbar: true})
      this.props.internal.setAllDataFromShoppingCart(load_data.data.data);
      //this.loadShoppingCart();
    }
    this.setState({loading: false})
    this.turnOffSnackBar()
  }

  updateBranchType = async (id) => {

    let load_data = await api({
      method: 'patch',
      url: 'shopping-cart',
      authorization: this.props.internal.user.access_token,
      params: {
        action: "attributes",
        branch_id: id
      }
    })

    if (load_data.success === true) {
      this.setState({message: load_data.data.message, openSnackbar: true, branch: load_data.data.data.branch})
      this.props.internal.setAllDataFromShoppingCart(load_data.data.data);
      //this.loadShoppingCart();
    }
    this.setState({loading: false})
    this.turnOffSnackBar()

  }


  formatMoney = (data) => {
    const formatter = new Intl.NumberFormat('sk-SK', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    })
    return formatter.format(data)
  }

  handleTogglePayment = value => () => {
    const {checkedPayment} = this.state;
    const currentIndex = checkedPayment.indexOf(value);
    const newChecked = [...checkedPayment];

    if (currentIndex === -1) {
      newChecked[0] = value;
      this.updatePaymentType(value)
    } else {
      newChecked.splice(currentIndex, 1);
      this.updatePaymentType(null)
    }

    this.setState({
      checkedPayment: newChecked,
    });
  };

  handleToggleDelivery = value => () => {

    const {checkedDelivery} = this.state;
    const currentIndex = checkedDelivery.indexOf(value);
    const newChecked = [...checkedDelivery];


    if (currentIndex === -1) {
      newChecked[0] = value;
      this.updateDeliveryType(value)
    } else {
      newChecked.splice(currentIndex, 1);
      this.updateDeliveryType(null)
    }

    this.setState({
      checkedDelivery: newChecked
    });
  };

  handleChangeBranche = event => {
    this.setState({branch: event.target.value});
    if (event.target.value === "") {
      this.updateBranchType(null)
    } else {
      this.updateBranchType(event.target.value.id)
    }
  };

  setNote = () => {
    // clearTimeout(this.timeout)
    // this.timeout =  setTimeout(() => {
    this.props.internal.setClientNote(this.note.state.value)
    // }, TIMEOUT)
  }

  setOrderNumber = () => {
    this.props.internal.setClientOrderNumber(this.order_number.state.value)
  }

  setDeliveryDate = (date) => {
    this.props.internal.setClientDeliveryDate(date);
  }

  branchces = toJS(this.props.internal.allDataFromShoppingCart.branches)

  branch_id = "";
  arrBranchces = []

  render () {
    if (this.arrBranchces.length === 0) {
      for (let prop in this.branchces) {
        let tmp = {id: this.branchces[prop].id, name: this.branchces[prop].name}
        this.arrBranchces.push(tmp)
      }
    }


    return (
      this.state.loading ?
        <CircularProgress className={'circular-progress'}/>
        :
        <div className={'payment-transport-tab'}>
          <CustomSnackbar message={this.state.message} open={this.state.openSnackbar}/>
          <Grid container>

            <Grid container className={'payment-transport-box'}>
              <Grid item md={12} lg={6} className={'payment-types'}>
                <Box>
                  <h2>{this.props.translate.i18n.GLOBAL.MENU.PAYMENTS}</h2>
                  <Divider/>
                  <div className={'list-payments'}>
                    <List>
                      {toJS(this.props.internal.allDataFromShoppingCart.available.payment_types).map((data, index) => {
                          return (
                            <ListItem key={data.id} onClick={this.handleTogglePayment(data.id)} className={'list-item'}>
                              <Checkbox
                                checked={this.state.checkedPayment.indexOf(data.id) !== -1}
                                tabIndex={-1}
                                disableRipple

                              />
                              <div className={'options-with-discount-msg'}>
                                <ListItemText primary={data.name} secondary={data.description} primaryTypographyProps={{className: 'primary-text'}}/>
                                {this.state.checkedPayment.indexOf(data.id) !== -1 && toJS(this.props.internal.allDataFromShoppingCart.payment_type_discount_message) !== null ?
                                  <span className={'discount-msg'}>{toJS(this.props.internal.allDataFromShoppingCart.payment_type_discount_message)}</span> : null}
                              </div>
                              <ListItemSecondaryAction>
                                <span className={'price'}>+ {toJS(this.props.internal.allDataFromShoppingCart.products_total) > data.free_from ? this.formatMoney(0) : this.formatMoney(data.price)}</span>
                              </ListItemSecondaryAction>
                            </ListItem>
                          )
                        }
                      )}
                    </List>
                  </div>
                </Box>
              </Grid>
              <Grid item md={12} lg={6} className={'payment-types'}>
                <Box>
                  <h2>{this.props.translate.i18n.GLOBAL.MENU.TRANSPORTS}</h2>
                  <Divider/>
                  <div className={'list-payments'}>
                    <List>
                      {toJS(this.props.internal.allDataFromShoppingCart.available.delivery_types).map((data, index) => {
                          return (
                            <ListItem key={data.id} onClick={this.handleToggleDelivery(data.id)} className={'list-item'}>
                              <Checkbox
                                checked={this.state.checkedDelivery.indexOf(data.id) !== -1}
                                tabIndex={-1}
                                disableRipple
                              />
                              <div className={'options-with-discount-msg'}>
                                <ListItemText primary={data.name} secondary={data.description} primaryTypographyProps={{className: 'primary-text'}}/>
                                {this.state.checkedDelivery.indexOf(data.id) !== -1 && toJS(this.props.internal.allDataFromShoppingCart.delivery_type_discount_message) !== null ?
                                  <span className={'discount-msg'}>{toJS(this.props.internal.allDataFromShoppingCart.delivery_type_discount_message)}</span> : null}

                              </div>
                              <ListItemSecondaryAction>
                                <span className={'price'}>+ {toJS(this.props.internal.allDataFromShoppingCart.products_total) > data.free_from ? this.formatMoney(0) : this.formatMoney(data.price)}</span>
                                {/* <span className={'price'}>+ {this.formatMoney(data.price)}</span> */}
                              </ListItemSecondaryAction>
                            </ListItem>
                          )
                        }
                      )}
                    </List>
                  </div>
                </Box>
              </Grid>
            </Grid>


            <Grid container className={'adress-total-box'}>
              <Grid item md={12} lg={6} className={'adresses'}>
                <Box>
                  <h2>{this.props.translate.i18n.MODULES.CLIENTS.ADDRESS}</h2>
                  <div className={'list-branchces'}>

                    {this.arrBranchces.length ?
                      <FormControl>
                        <InputLabel htmlFor="branchces">{this.props.translate.i18n.MODULES.CLIENTS.BRANCH}</InputLabel>
                        <Select
                          className={'select-branche'}
                          // value={this.arrBranchces.length && Number(this.arrBranchces[0].id) === Number(this.state.branch) ? this.arrBranchces[0].id : this.state.branch }
                          value={this.state.branch ? this.state.branch.name : ""}
                          onChange={this.handleChangeBranche}
                          inputProps={{
                            name: 'branchces',
                            id: 'branchces',
                          }}
                          renderValue={selected => {return (<span>{selected}</span>)}}
                          disabled={this.arrBranchces.length ? false : true}
                        >
                          {this.arrBranchces.map((branch, index) => {

                            return (
                              <MenuItem key={branch.id} value={branch}>{branch.name}</MenuItem>
                            )
                          })}

                        </Select>
                      </FormControl>
                      :
                      null
                    }
                  </div>
                </Box>
              </Grid>
              <Grid item md={12} lg={6} className={'summary'}>
                <Box>
                  <h2 className={'note-title'}>{this.props.translate.i18n.MODULES.CLIENTS.ADDITIONAL_INFO}</h2>
                  <CustomInput
                    ref={ref => this.order_number = ref}
                    text={this.props.translate.i18n.MODULES.CLIENTS.WRITE_ORDER_NUMBER}
                    id={'order_number'}
                    className={`w-100 order-number`}
                    change={this.setOrderNumber}
                    multiline={false}
                  />
                  <MuiThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider utils={MomentUtils} locale={this.state.locale} moment={moment}>
                      <DatePicker
                        onChange={this.setDeliveryDate}
                        label={this.props.translate.i18n.MODULES.CLIENTS.WRITE_DELIVERY_DATE}
                        okLabel={
                          <span style={{color: "#FF7800"}}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>}
                        cancelLabel={<span>{this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}</span>}
                        autoOk
                        disablePast
                        maxDate={moment().add(6, 'month').format('YYYY-MM-DD')}
                        showTabs={false}
                        allowKeyboardControl={false}
                        labelFunc={date => (date ? date.format('DD.MM.YYYY') : '')}
                        value={this.props.internal.clientDeliveryDate}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton style={{padding: 6}}>
                                <CalendarToday/>
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </MuiThemeProvider>
                  <CustomInput
                    ref={ref => this.note = ref}
                    text={this.props.translate.i18n.MODULES.CLIENTS.WRITE_NOTE}
                    id={'note'}
                    className={`w-100 note`}
                    change={this.setNote}
                    multiline={true}
                  />
                </Box>
                <Box>
                  <div className={'flex with-vat'}>
                    <p>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITHOUT_VAT}</p>
                    <span>{this.formatMoney(this.props.internal.allDataFromShoppingCart.total)}</span>
                  </div>
                  {(this.props.internal.allDataFromShoppingCart.cent_correction !== null) ? <div className={'flex without-vat'}>
                    <p>{this.props.translate.i18n.MODULES.CLIENTS.CENT_CORRECTION}</p>
                    <span>{this.formatMoney(this.props.internal.allDataFromShoppingCart.cent_correction)} </span>
                  </div> : null}
                  <div className={'flex without-vat'}>
                    <p>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITH_VAT}</p>
                    <span>{this.formatMoney(this.props.internal.allDataFromShoppingCart.total_with_vat)} </span>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </div>
    )
  }

}

@inject('internal')
@inject('translate')
@observer
class Summary extends React.Component {
  constructor (props) {
    super(props);
    this.state = {}
  }

  formatMoney = (data) => {
    const formatter = new Intl.NumberFormat('sk-SK', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    })
    return formatter.format(data)
  }

  render () {
    let deliveryDate = toJS(this.props.internal.clientDeliveryDate);
    let orderNumber = toJS(this.props.internal.clientOrderNumber);
    return (
      <div className={'summary-tab'}>
        <Paper style={{overflow: "auto"}}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{this.props.translate.i18n.MODULES.SHOPPING_CART.EAN}</TableCell>
                <TableCell>{this.props.translate.i18n.MODULES.SHOPPING_CART.TITLE}</TableCell>
                <TableCell className={'text-right'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.PRICE_WITHOUT_VAT}</TableCell>
                <TableCell className={'text-right'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.COUNT}</TableCell>
                <TableCell className={'text-right'}>{this.props.translate.i18n.MODULES.SHOPPING_CART.TOTAL}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.internal.shoppingCart.map((item, itemIndex) => {
                return (
                  <TableRow key={item.product.id}>
                    <TableCell>{item.product.code}</TableCell>
                    <TableCell>{item.product.name}</TableCell>
                    <TableCell className={'text-right'}>{this.formatMoney(item.total_price)}</TableCell>
                    <TableCell className={'text-right'}>{item.quantity}</TableCell>
                    <TableCell className={'text-right'}>{this.formatMoney(item.total_price_with_vat)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>

        <Grid container className={'payment-transport-box'}>
          <Grid item md={12} lg={6} className={'payment-types'}>
            <Box>
              <h2>{this.props.translate.i18n.GLOBAL.MENU.PAYMENTS}</h2>
              <Divider/>
              <div className={'list-payments'}>
                <List>
                  <ListItem className={'list-item'}>
                    <Checkbox
                      checked={true}
                      tabIndex={-1}
                      disableRipple
                    />
                    {/* <ListItemText primary={toJS(this.props.internal.allDataFromShoppingCart.payment_type.name)} secondary={toJS(this.props.internal.allDataFromShoppingCart.payment_type.description)} primaryTypographyProps={{className: 'primary-text'}}/>
                                        <ListItemSecondaryAction>
                                            <span className={'price'}>+ {this.formatMoney(toJS(this.props.internal.allDataFromShoppingCart.payment_type.price))}</span>
                                        </ListItemSecondaryAction> */}

                    <div className={'options-with-discount-msg'}>
                      <ListItemText primary={toJS(this.props.internal.allDataFromShoppingCart.payment_type.name)} secondary={toJS(this.props.internal.allDataFromShoppingCart.payment_type.description)} primaryTypographyProps={{className: 'primary-text'}}/>
                      {toJS(this.props.internal.allDataFromShoppingCart.payment_type_discount_message) !== null ?
                        <span className={'discount-msg'}>{toJS(this.props.internal.allDataFromShoppingCart.payment_type_discount_message)}</span> : null}
                    </div>
                    <ListItemSecondaryAction>
                      <span className={'price'}>+ {toJS(this.props.internal.allDataFromShoppingCart.products_total) > toJS(this.props.internal.allDataFromShoppingCart.payment_type.free_from) ? this.formatMoney(0) : this.formatMoney(toJS(this.props.internal.allDataFromShoppingCart.payment_type.price))}</span>
                    </ListItemSecondaryAction>

                  </ListItem>
                </List>
              </div>
            </Box>
          </Grid>
          <Grid item md={12} lg={6} className={'payment-types'}>
            <Box>
              <h2>{this.props.translate.i18n.GLOBAL.MENU.TRANSPORTS}</h2>
              <Divider/>
              <div className={'list-payments'}>
                <List>
                  <ListItem className={'list-item'}>
                    <Checkbox
                      checked={true}
                      tabIndex={-1}
                      disableRipple
                    />
                    {/* <ListItemText primary={toJS(this.props.internal.allDataFromShoppingCart.delivery_type.name)} secondary={toJS(this.props.internal.allDataFromShoppingCart.delivery_type.description)} primaryTypographyProps={{className: 'primary-text'}}/>
                                        <ListItemSecondaryAction>
                                            <span className={'price'}>+ {this.formatMoney(toJS(this.props.internal.allDataFromShoppingCart.delivery_type.price))}</span>
                                        </ListItemSecondaryAction> */}

                    <div className={'options-with-discount-msg'}>
                      <ListItemText primary={toJS(this.props.internal.allDataFromShoppingCart.delivery_type.name)} secondary={toJS(this.props.internal.allDataFromShoppingCart.delivery_type.description)} primaryTypographyProps={{className: 'primary-text'}}/>
                      {toJS(this.props.internal.allDataFromShoppingCart.delivery_type_discount_message) !== null ?
                        <span className={'discount-msg'}>{toJS(this.props.internal.allDataFromShoppingCart.delivery_type_discount_message)}</span> : null}
                    </div>
                    <ListItemSecondaryAction>
                      <span className={'price'}>+ {toJS(this.props.internal.allDataFromShoppingCart.products_total) > toJS(this.props.internal.allDataFromShoppingCart.delivery_type.free_from) ? this.formatMoney(0) : this.formatMoney(toJS(this.props.internal.allDataFromShoppingCart.delivery_type.price))}</span>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </div>
            </Box>
          </Grid>
        </Grid>
        <Grid container className={'adress-total'}>
          <Grid item md={12} lg={6} className={'adress'}>
            <Box>
              <h2>{this.props.translate.i18n.MODULES.CLIENTS.ADDRESS}</h2>
              <Divider/>
              <div className={'adress-data'}>
                <span>{this.props.internal.allDataFromShoppingCart.branch.street_name} {this.props.internal.allDataFromShoppingCart.branch.street_no}</span>
                <span>{this.props.internal.allDataFromShoppingCart.branch.zip}</span>
                <span>{this.props.internal.allDataFromShoppingCart.branch.city}</span>
                <span>{this.props.internal.allDataFromShoppingCart.branch.country}</span>
              </div>
            </Box>
          </Grid>
          <Grid item md={12} lg={6} className={'summary note'}>
            <Box>
              <h2 className={'note-title'}>{this.props.translate.i18n.MODULES.CLIENTS.ADDITIONAL_INFO}</h2>
              <Divider/>
              <div style={{padding: '27px 24px', lineHeight: 1.2}}>
                <div>
                  <strong>{this.props.translate.i18n.MODULES.CLIENTS.WRITE_ORDER_NUMBER}:</strong>
                  <span>{orderNumber || 'N/A'}</span>
                </div>
                <div>
                  <strong>{this.props.translate.i18n.MODULES.CLIENTS.WRITE_DELIVERY_DATE}:</strong>
                  <span>{deliveryDate ? deliveryDate.format('DD.MM.YYYY') : 'N/A'}</span>
                </div>
                <div>
                  <div><strong>{this.props.translate.i18n.MODULES.CLIENTS.NOTE}</strong></div>
                  <div style={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 'initial'
                  }}>{toJS(this.props.internal.clientNote)}</div>
                </div>
              </div>
            </Box>
          </Grid>
        </Grid>
        <Grid container className={'adress-total prices'}>
          <Grid item md={12} lg={6} className={'summary '}>
            <Box>
              <div className={'flex with-vat'}>
                <p>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITHOUT_VAT}</p>
                <span>{this.formatMoney(this.props.internal.allDataFromShoppingCart.total)}</span>
              </div>
              {(this.props.internal.allDataFromShoppingCart.cent_correction !== null) ? <div className={'flex without-vat'}>
                <p>{this.props.translate.i18n.MODULES.CLIENTS.CENT_CORRECTION}</p>
                <span>{this.formatMoney(this.props.internal.allDataFromShoppingCart.cent_correction)} </span>
              </div> : null}
              <div className={'flex without-vat'}>
                <p>{this.props.translate.i18n.MODULES.CLIENTS.TOTAL_PRICE_WITH_VAT}</p>
                <span>{this.formatMoney(this.props.internal.allDataFromShoppingCart.total_with_vat)} </span>
              </div>
            </Box>
          </Grid>
        </Grid>
      </div>
    )
  }

}

@inject('internal')
@inject('translate')
@observer
class CompleteOrder extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      // message: this.props.internal.dataSnackbar.msg,
      // openSnackbar: this.props.internal.dataSnackbar.open,
    }
  }

  componentDidMount () {
    // this.turnOffSnackBar()
    this.props.internal.updateNumberOfItemsInShopingCart(0)
  }

  timeout = null;

  componentWillUnmount () {
    clearTimeout(this.timeout)
  }

  // turnOffSnackBar = () => {
  //     clearTimeout(this.timeout)
  //     this.timeout = setTimeout(() => {
  //         this.setState({
  //             message: "",
  //             openSnackbar: false
  //         })
  //     }, TIMEOUT)
  // }

  goToPreviewOrder = () => {
    let clientId = toJS(this.props.internal.user.data.client.id)
    let orderId = toJS(this.props.internal.allDataFromShoppingCart.id);
    this.props.internal.pushRoute(`/clients/${clientId}/orders/${orderId}`);
    let data = {
      edit: true,
      id: orderId
    }
    this.props.internal.setActionEdit(data)
  }

  goToNewOrder = () => {
    this.props.internal.pushRoute('/products')
  }

  render () {
    return (
      <div className={'complete-order'}>
        {/* <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} /> */}
        <h1>{this.props.translate.i18n.GLOBAL.ORDER.THANK_YOU}</h1>
        <p>{this.props.translate.i18n.GLOBAL.ORDER.MESSAGE}</p>
        <div className={'btns'}>
          <Button variant="contained" className={'btn-new-order'} onClick={this.goToNewOrder}>
            {this.props.translate.i18n.GLOBAL.ORDER.NEW}
          </Button>
          <Button variant="contained" className={'btn-show-order'} onClick={this.goToPreviewOrder}>
            {this.props.translate.i18n.GLOBAL.ORDER.SHOW}
          </Button>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/screens/products/shoppingCart/index.js